import { createContext, FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  GetProductGroupQuery,
  useGetProductGroupLazyQuery,
} from "src/generated/graphql";

export type IproductGroupData = GetProductGroupQuery["productGroupOne"];
export type IvariantMetrics = NonNullable<
  GetProductGroupQuery["productGroupOne"]
>["metrics"];
export type Iproducts = NonNullable<
  GetProductGroupQuery["productGroupOne"]
>["products"];

export type ProductContextData = {
  groupId: string | undefined;
  productGroupData: IproductGroupData | undefined;
  variantMetrics: IvariantMetrics;
  products: Iproducts;
};
export const ProductContext = createContext<ProductContextData>(
  {} as ProductContextData
);

interface Props {
  children: React.ReactNode;
}

const ProductProvider: FC<Props> = ({ children }) => {
  const { groupId } = useParams<{ groupId: string }>();
  const [getProductGroup, { data: productGroupData }] =
    useGetProductGroupLazyQuery();

  useEffect(() => {
    groupId &&
      getProductGroup({
        variables: { productGroupOneId: groupId },
      });
  }, [groupId, getProductGroup]);

  return (
    <ProductContext.Provider
      value={{
        productGroupData: productGroupData?.productGroupOne,
        variantMetrics: productGroupData?.productGroupOne?.metrics || [],
        groupId: groupId,
        products: productGroupData?.productGroupOne?.products || [],
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};

export default ProductProvider;
